import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-home-white',
  templateUrl: './icon-home-white.component.html',
  styles: []
})
export class IconHomeWhiteComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
